// Public URLs for static assets
export const ASSETS = {
  LOGO: {
    ICON: 'https://xzuqaozewgmhhvjfkskl.supabase.co/storage/v1/object/public/public/blooma%20icon.png',
    FULL: '/Horizontal Logo no Tagline.png'
  }
} as const;